import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'

// Quill
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

async function checkAuth() {
  const nodeEnv = config.nodeEnv
  let token = null

  if (nodeEnv === 'local') {
    token = config.token
  } else {
    const params = new URLSearchParams(window.location.search)
    const urlToken = params.get('token_jwt')

    if (urlToken) {
      sessionStorage.setItem('token_jwt', urlToken)
      localStorage.setItem('token_jwt', urlToken)
      document.cookie = `token_jwt=${urlToken}; path=/; SameSite=Lax`
      window.history.replaceState({}, document.title, window.location.pathname)
    }

    token =
      sessionStorage.getItem('token_jwt') ||
      localStorage.getItem('token_jwt') ||
      document.cookie.match(/token_jwt=([^;]+)/)?.[1]
  }

  if (!token) return false

  try {
    const res = await fetch(`${config.API_URL}test-token`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    if (!res.ok) throw new Error('Token invalid')

    const data = await res.json()

    // 🔥 INI YANG SEBELUMNYA KURANG
    localStorage.setItem(
      'user_data',
      JSON.stringify({
        user: data.user,
        menu: data.menu
      })
    )

    return true
  } catch (err) {
    console.error('Auth error:', err)
    return false
  }
}

(async () => {
  const isLogin = await checkAuth()

  if (!isLogin) {
    window.location.replace(config.url_FE)
    return
  }

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
})()
